var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import loadable from '@loadable/component';
var ActivityDetailLangController = /** @class */function () {
  function ActivityDetailLangController() {
    this.pageId = 'ActivityDetails';
    this.path = '/things-to-do/:lang/:title?.a:activityId\\.([a-z\\-]{5,})';
    this.routeName = 'activity-detail';
    // eslint-disable-next-line import/no-unresolved
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "example-page";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function () {
        return import(/* webpackChunkName: "example-page" */'views/test');
      },
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/test");
        }
        return eval('require.resolve')("views/test");
      }
    });
    this.exact = true;
    this.caseSensitive = true;
    this.useV5RoutePaths_deprecated = true; // eslint-disable-line
  }
  ActivityDetailLangController.prototype.fetch = function (options) {
    return __awaiter(this, void 0, Promise, function () {
      var stores, activityDetailStore, unwantedKeys, lang, queryObject;
      return __generator(this, function (_a) {
        stores = options.stores;
        activityDetailStore = stores.get('activityDetailStore');
        unwantedKeys = ['lang', 'title', 'activityId', '0'];
        lang = this.getLang(options.query);
        queryObject = __assign(__assign({}, options.query), {
          langid: lang.toString()
        });
        activityDetailStore.detailUrl = "".concat("/things-to-do/".concat(options.query.title, ".a").concat(options.query.activityId, ".").concat(options.query['0'], "?")).concat(Object.keys(queryObject).filter(function (t) {
          return unwantedKeys.indexOf(t) === -1;
        }).map(function (key) {
          return "".concat(key, "=").concat(queryObject[key]);
        }).join('&'));
        return [2 /*return*/, Promise.resolve()];
      });
    });
  };
  /* eslint-disable class-methods-use-this  */
  ActivityDetailLangController.prototype.getLang = function (params) {
    if (params && params.lang) {
      switch (params.lang) {
        case 'es':
          return 2058;
        case 'zh':
          return 2052;
        default:
          return 0;
      }
    }
    return 0;
  };
  ActivityDetailLangController.prototype.fetchPageData = function () {
    return Promise.resolve({
      title: '',
      pageId: this.pageId
    });
  };
  return ActivityDetailLangController;
}();
export { ActivityDetailLangController };